import React from 'react';
import { withTheme } from 'styled-components';
import {Button} from '@pearsontechnology/aero-components';
import { intl } from 'containers/LanguageProvider/IntlGlobalProvider';
import messages from './messages';
import Modal from 'components/Modal';
import { UnauthorizedModalContent, UnauthorizedModalActions } from './styles';


const UnauthorizedModal = ({visible, onDismiss}) => (
  <Modal visible={visible} onDismiss={onDismiss}>
    <UnauthorizedModalContent>
      {intl.formatMessage(messages.unauthorizedMessage)}
    </UnauthorizedModalContent>
    <UnauthorizedModalActions>
      <Button primary onClick={onDismiss}>{intl.formatMessage(messages.ok)}</Button>
    </UnauthorizedModalActions>
  </Modal >
);

export default withTheme(UnauthorizedModal);
